import facilitiesService from '@/services/facilities.service'

export default {
  // 📋 Fetch users list
  async fetchFacilities({ commit, state }, payload = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const filters = { ...state.filters, ...payload }
      commit('SET_FILTERS', filters)

      const res = await facilitiesService.getFacilities(filters)
  
      commit('SET_FACILITIES', res)
      commit('SET_PAGINATION', res.meta)
      
      return res
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch users')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // ➕ create facility
  async createFacility({ commit }, data) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_MESSAGE', null)

    try {
      const { data: facility, message } =
        await facilitiesService.createFacility(data)

        commit('ADD_FACILITY', facility)
        commit('SET_MESSAGE', message)

      return facility

    } catch (err) {
      commit('SET_ERROR', {
        message: err.message || 'Something went wrong',
        errors: err.errors
      })

      throw err // 🔥 important if component needs it
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 👤 Get single facility
  async fetchFacility({ commit }, id) {
    commit('SET_LOADING', true)

    try {
      const facility = await facilitiesService.getFacility(id)
      commit('SET_FACILITY', facility)
      return facility
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch facility')
    } finally {
      commit('SET_LOADING', false)
    }
  },


  // ✏️ Update
  async updateFacility({ commit }, { id, data }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_MESSAGE', null)

    try {
      const { data: facility, message } =
        await facilitiesService.updateFacility(id, data)

      commit('ADD_FACILITY', facility)
      commit('SET_MESSAGE', message)

      return facility

    } catch (err) {
      commit('SET_ERROR', {
        message: err.message,
        errors: err.errors
      })

      throw err // 🔥 important if component needs it
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // ❌ Delete
  async deleteFacility({ commit }, id) {
    commit('SET_ERROR', null)
    commit('SET_MESSAGE', null)
    try {
      const res = await facilitiesService.deleteFacility(id)
      commit('SET_MESSAGE', res.message||'Facility deactivated successfully')
      return res
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to deactivat facility')
    }
  },

   async exportFacilities({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_MESSAGE', null)
    try {
      const report = await facilitiesService.exportFacilities()
      commit('SET_REPORT', report)
      if (report.url) {
        commit('SET_MESSAGE',  'Facilities downloaded successfully')
      } else {
        commit('SET_ERROR',  {message:'There is no data available to generate this report.'})
      }
      return report
    } catch (err) {
      commit('SET_ERROR', err || 'Failed to fetch report')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async resetFacility({ commit }) {
    await commit('RESET_FACILITY')
  },

  async clearMessage({ commit }) {
    commit('SET_MESSAGE', null)
    commit('SET_ERROR', null)
  },
}